var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_bar)?_c('v-system-bar',{staticClass:"text-center",staticStyle:{"transition":"0.3s ease-in-out"},attrs:{"app":"","fixed":"","dark":"","color":_vm.colorMap[_vm.status]}},[_c('span',{staticClass:"d-block text-center white--text",staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.toast_msg)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }